// extracted by mini-css-extract-plugin
module.exports = {"root":"contact-client-inquiries-module--root--2JqJN","aboutSubtext":"contact-client-inquiries-module--aboutSubtext--3SMz-"};